import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0952 22.4604L13.8068 15.1139V15.0542H9.49858V13.7332H15.4432V15.084L11.7358 22.4604H10.0952ZM19.7354 22.5798C19.1673 22.5798 18.6587 22.4732 18.2099 22.2602C17.761 22.0443 17.4045 21.7488 17.1403 21.3738C16.8789 20.9988 16.7397 20.5698 16.7227 20.0869H18.2567C18.2852 20.4448 18.44 20.7374 18.7212 20.9647C19.0025 21.1891 19.3406 21.3014 19.7354 21.3014C20.0451 21.3014 20.3207 21.2303 20.5621 21.0883C20.8036 20.9462 20.994 20.7488 21.1332 20.496C21.2724 20.2431 21.3406 19.9548 21.3377 19.6309C21.3406 19.3014 21.271 19.0087 21.1289 18.7531C20.9869 18.4974 20.7923 18.2971 20.5451 18.1522C20.2979 18.0045 20.0138 17.9306 19.6928 17.9306C19.4315 17.9278 19.1744 17.9761 18.9215 18.0755C18.6687 18.1749 18.4684 18.3056 18.3207 18.4676L16.8931 18.2332L17.3491 13.7332H22.4116V15.0542H18.6573L18.4059 17.3681H18.457C18.619 17.1778 18.8477 17.0201 19.1431 16.8951C19.4386 16.7673 19.7624 16.7033 20.1147 16.7033C20.6431 16.7033 21.1147 16.8283 21.5295 17.0783C21.9442 17.3255 22.271 17.6664 22.5096 18.1011C22.7482 18.5357 22.8675 19.0329 22.8675 19.5926C22.8675 20.1693 22.734 20.6835 22.467 21.1352C22.2028 21.584 21.8349 21.9377 21.3633 22.1962C20.8945 22.4519 20.3519 22.5798 19.7354 22.5798Z"
      className="number-fill"
      fill="currentColor"
    />
    <path
      d="M2.43273 24.4647C1.82956 22.8395 1.5 21.0813 1.5 19.2461C1.5 10.9618 8.21573 4.24609 16.5 4.24609C24.7843 4.24609 31.5 10.9618 31.5 19.2461C31.5 21.1213 31.1559 22.9161 30.5274 24.5708L28.1106 23.6639C28.6332 22.2913 28.9193 20.8021 28.9193 19.2461C28.9193 12.3871 23.359 6.82673 16.5 6.82673C9.64097 6.82673 4.08064 12.3871 4.08064 19.2461C4.08064 20.7621 4.35227 22.2147 4.84952 23.5578L2.43273 24.4647Z"
      stroke="#2CB46B"
      className="gauge-fill"
      fill="currentColor"
    />
    <path
      d="M16.5 6.82674C19.4198 6.82674 22.1043 7.83435 24.2248 9.52085C25.1984 10.2952 26.053 11.2127 26.757 12.2415L28.9199 10.8324C28.0717 9.58275 27.0399 8.46788 25.8632 7.52654C23.297 5.47367 20.0419 4.24609 16.5 4.24609C8.21573 4.24609 1.5 10.9618 1.5 19.2461C1.5 21.0812 1.82956 22.8394 2.43272 24.4647L4.84951 23.5577C4.35227 22.2146 4.08065 20.7621 4.08065 19.2461C4.08065 12.3871 9.64098 6.82674 16.5 6.82674Z"
      className="gauge-fill"
      fill="currentColor"
    />
  </svg>,
  'GaugeChartIcon'
);

export const GaugeChartIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.number-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.gauge-fill': {
          color: theme.palette.status.success.main,
        },
      })}
    />
  );
};
